import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import assign from "lodash/fp/assign";

import Button from "./Button.jsx";
import handleComponentsProp from "./handleComponentsProp.js";
import Icon from "./Icon.jsx";
import useThemeProps from "./useThemeProps.jsx";

const DefaultButton = styled(Button, {
  // shouldForwardProp: (prop) => !["hoverColor"].includes(prop),
})``;

export default function ClickableIcon(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "ClickableIcon" });
  let {
    name,
    icon,
    src,
    size,
    padding = 2,
    color,
    variant = null,
    components,
    borderRadius = "9999px",
    label,
    ...restProps
  } = props;
  let { Button } = handleComponentsProp(components, { Button: DefaultButton });
  icon = assign(icon, { name, src, size, color: [color, "icon"] });
  return (
    <Button
      css={css`
        padding: ${theme.getLength(padding)};
        margin: calc(-1 * ${theme.getLength(padding)});
        border-radius: 9999px;
      `}
      variant={variant}
      color={color}
      borderRadius={borderRadius}
      aria-label={label}
      {...restProps}
    >
      <Icon {...icon} />
    </Button>
  );
}
